import { constructFrom as i } from "./constructFrom.js";
import { getDefaultOptions as M } from "./getDefaultOptions.js";
import { toDate as q } from "./toDate.js";
import { longFormatters as z } from "./_lib/format/longFormatters.js";
import { isProtectedWeekYearToken as U, warnOrThrowProtectedError as Q, isProtectedDayOfYearToken as Z } from "./_lib/protectedTokens.js";
import { parsers as B } from "./parse/_lib/parsers.js";
import { DateToSystemTimezoneSetter as G } from "./parse/_lib/Setter.js";
import { enUS as J } from "./locale/en-US.js";
const S = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, V = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, X = /^'([^]*?)'?$/, _ = /''/g, ee = /\S/, te = /[a-zA-Z]/;
function me(n, l, s, r) {
  var T, w, d, y, N, O, p, E, R, x, C, P, W, b, A, F, $, Y;
  const c = M(), f = (w = (T = r == null ? void 0 : r.locale) != null ? T : c.locale) != null ? w : J, v = (x = (R = (O = (N = r == null ? void 0 : r.firstWeekContainsDate) != null ? N : (y = (d = r == null ? void 0 : r.locale) == null ? void 0 : d.options) == null ? void 0 : y.firstWeekContainsDate) != null ? O : c.firstWeekContainsDate) != null ? R : (E = (p = c.locale) == null ? void 0 : p.options) == null ? void 0 : E.firstWeekContainsDate) != null ? x : 1, H = (Y = ($ = (b = (W = r == null ? void 0 : r.weekStartsOn) != null ? W : (P = (C = r == null ? void 0 : r.locale) == null ? void 0 : C.options) == null ? void 0 : P.weekStartsOn) != null ? b : c.weekStartsOn) != null ? $ : (F = (A = c.locale) == null ? void 0 : A.options) == null ? void 0 : F.weekStartsOn) != null ? Y : 0;
  if (l === "")
    return n === "" ? q(s) : i(s, NaN);
  const m = {
    firstWeekContainsDate: v,
    weekStartsOn: H,
    locale: f
  }, u = [new G()], I = l.match(V).map((e) => {
    const t = e[0];
    if (t in z) {
      const a = z[t];
      return a(e, f.formatLong);
    }
    return e;
  }).join("").match(S), k = [];
  for (let e of I) {
    !(r != null && r.useAdditionalWeekYearTokens) && U(e) && Q(e, l, n), !(r != null && r.useAdditionalDayOfYearTokens) && Z(e) && Q(e, l, n);
    const t = e[0], a = B[t];
    if (a) {
      const { incompatibleTokens: D } = a;
      if (Array.isArray(D)) {
        const L = k.find(
          (j) => D.includes(j.token) || j.token === t
        );
        if (L)
          throw new RangeError(
            `The format string mustn't contain \`${L.fullToken}\` and \`${e}\` at the same time`
          );
      } else if (a.incompatibleTokens === "*" && k.length > 0)
        throw new RangeError(
          `The format string mustn't contain \`${e}\` and any other token at the same time`
        );
      k.push({ token: t, fullToken: e });
      const g = a.run(
        n,
        e,
        f.match,
        m
      );
      if (!g)
        return i(s, NaN);
      u.push(g.setter), n = g.rest;
    } else {
      if (t.match(te))
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + t + "`"
        );
      if (e === "''" ? e = "'" : t === "'" && (e = re(e)), n.indexOf(e) === 0)
        n = n.slice(e.length);
      else
        return i(s, NaN);
    }
  }
  if (n.length > 0 && ee.test(n))
    return i(s, NaN);
  const K = u.map((e) => e.priority).sort((e, t) => t - e).filter((e, t, a) => a.indexOf(e) === t).map(
    (e) => u.filter((t) => t.priority === e).sort((t, a) => a.subPriority - t.subPriority)
  ).map((e) => e[0]);
  let o = q(s);
  if (isNaN(o.getTime()))
    return i(s, NaN);
  const h = {};
  for (const e of K) {
    if (!e.validate(o, m))
      return i(s, NaN);
    const t = e.set(o, h, m);
    Array.isArray(t) ? (o = t[0], Object.assign(h, t[1])) : o = t;
  }
  return i(s, o);
}
function re(n) {
  return n.match(X)[1].replace(_, "'");
}
export {
  me as default,
  z as longFormatters,
  me as parse,
  B as parsers
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns@3.6.0/~/date-fns/parse.js
// module id = 1406
// module chunks = 67